module.exports = __webpack_public_path__ + "static/media/Milex-Ring-Pessary-Instructions-for-Use@3x.920547b1.jpg";